import React from "react";
import { Popover } from "../../ui/Popover";
import { FiltersPanel } from "./FiltersPanel";

/** Desktop presentation: the shared panel floating out of the dock. */
const POPOVER_WIDTH_PX = 302;

/**
 * @param {Object} props
 * @param {boolean} props.open
 * @param {React.RefObject<HTMLElement>} props.anchorRef
 * @param {() => void} props.onClose
 * @param {Object} props.panelProps - Forwarded to FiltersPanel.
 */
export function FiltersPopover({ open, anchorRef, onClose, panelProps }) {
  return (
    <Popover
      open={open}
      anchorRef={anchorRef}
      onClose={onClose}
      label="Coaching signals"
      width={POPOVER_WIDTH_PX}
    >
      <FiltersPanel {...panelProps} onDone={onClose} />
    </Popover>
  );
}

export default FiltersPopover;
